import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { IconWrapper } from '@framework/ui/components/icon/IconWrapper.tsx';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';
import styled from 'styled-components';
import { useMarkNotificationAsRead } from './useMarkNotificationAsRead.ts';

const SecondaryText = styled.span`
  color: ${props => props.theme.colorTextSecondary};
  font-size: 12px;
  display: inline-flex;
  line-height: 1.3;
  padding-bottom: 1px;
  span {
    margin-left: 5px;
  }
  .anticon {
    color: ${props => props.theme.colorPrimary};
  }
`;
const MinimalButton = styled(Button)`
  &&& {
    font-size: 13px;
    font-weight: 400;
    height: auto;
  }
`;

interface ButtonNotificationReadProps {
  read?: Date | null;
  notificationId: string;
}

/**
 * Pulsante per segnare una notifica come letta
 */
export function ButtonNotificationRead(props: ButtonNotificationReadProps) {
  const { read, notificationId } = props;
  const { t } = useTranslation();
  const { markAsRead, isRead } = useMarkNotificationAsRead({
    notificationId,
    read,
  });

  const markAsReadText = t('notifiche.segna-come-letta', 'Segna come letta');
  const readText = t('notifiche.letta-il', 'Letta il');

  return (
    <>
      {isRead ? (
        <SecondaryText>
          {readText} <ISODate date={read} />
          <IconWrapper icon={<FaCheck aria-hidden="true" />} />
        </SecondaryText>
      ) : (
        <MinimalButton size="small" type="primary" ghost onClick={markAsRead}>
          {markAsReadText} <IconWrapper icon={<FaCheck aria-hidden="true" />} />
        </MinimalButton>
      )}
    </>
  );
}
